import '@popperjs/core/dist/esm/popper.js';

import { Carousel, Collapse, Dropdown, Offcanvas } from 'bootstrap';

import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

(function($) {

  // Desktop navigation - hover on dropdown
  document.addEventListener("DOMContentLoaded", function(){
    if (window.innerWidth > 992) {
      document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem){
        everyitem.addEventListener('mouseover', function(e){
          let el_link = this.querySelector('a[data-bs-hover]');
          if(el_link != null){
            let nextEl = el_link.nextElementSibling;
            el_link.classList.add('show');
            nextEl.classList.add('show');
          }
        });
        everyitem.addEventListener('mouseleave', function(e){
          let el_link = this.querySelector('a[data-bs-hover]');
          if(el_link != null){
            let nextEl = el_link.nextElementSibling;
            el_link.classList.remove('show');
            nextEl.classList.remove('show');
          }
        })
      });
    }
  });

  // Function to check if element exists
  jQuery.fn.exists = function(){ return jQuery(this).length>0; }

  // Set up splide
  document.addEventListener( 'DOMContentLoaded', function () {

    if ($('.splide').exists()) {
      new Splide( '.splide',{
        type   : 'loop',
        perPage: 12,
        autoWidth: true,
        autoheight: true,
        arrows: false,
        gap: 30,
        pagination: false,
        autoScroll: {
          speed: 0.75,
        },
      } ).mount( { AutoScroll } );
    }

  } );

  // Close mobile nav when hashed link is clicked but page is not refreshed / changed
  $( document ).ready(function() {
    var navLinks = document.querySelectorAll('.mobile-nav a[href*="about/#"]')
    var menuToggle = document.getElementById('mobileNav')
    var bsOffcanvas = new Offcanvas(menuToggle, {backdrop: false})
    navLinks.forEach((l) => {
      l.addEventListener('click', () => { bsOffcanvas.toggle() })
    })
  });

})( jQuery );